<div
	class="card-title px-4 pt-5 text-center text-base font-bold text-fmsDarkBlue sm:px-6 md:text-xl"
>
	<ng-content />
</div>
